module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; __append("\nDear forge administrator,\n\nThe mission of Software Heritage is to collect, preserve and share all the\npublicly available source code (see https://www.softwareheritage.org for more\ninformation).\n\nWe just received a request to add the forge hosted at ")
    ; __append(escapeFn( forgeUrl ))
    ; __append(" to the\nlist of software origins that are archived, and it is our understanding that you\nare the contact person for this forge.\n\nIn order to archive the forge contents, we will have to periodically pull the\npublic repositories it contains and clone them into the\nSoftware Heritage archive.\n\nWould you be so kind as to reply to this message to acknowledge the reception\nof this email and let us know if there are any special steps we should take in\norder to properly archive the public repositories hosted on your infrastructure?\n\nThank you in advance for your help.\n\nKind regards,\nThe Software Heritage team\n")
  }
  return __output;

}